import React, {useCallback, useState} from 'react';
import {getCookie, setCookie} from "../../../shared";
import {CookieAgreement} from "../../../components";
import styles from './CookieChecker.module.scss';
import {AppSettings} from "../../../settings";

export const CookieChecker = (props) => {
  const [userCookiesAllowed, refreshState] = useState(getCookie(AppSettings.cookieName) === 'true');
  const onAgreementCookie = useCallback(() => {
    setCookie(AppSettings.cookieName, 'true', AppSettings.cookieExpirationDays);
    refreshState(true);
  }, [refreshState]);

  return !userCookiesAllowed && <>
    <CookieAgreement className={styles.container} onAgreementCookie={onAgreementCookie}/>
    <div className={styles.overlay} />
  </>;
};

CookieChecker.propTypes = {}

CookieChecker.defaultProps = {}

export default React.memo(CookieChecker);